import React from "react";
import { Transition } from "@headlessui/react";
import { Column } from "react-table";
import DeltaMathTable from "../../../shared/DeltaMathTable";
import { UsageLocalStorageInterface } from "../ReportTypes";

/**
 * The TSX component for rendering a table that allows the selection of schools, teachers, or sections within the context of student reports.
 * To-Do: Currently this is only leveraged by Usage Reports, we can also update the performance report component to leverage this table.
 */
function UsageSelectionTable<TableData>({
  tableData,
  columns,
  stateData,
  setStateData,
  stateDataKey,
}: {
  tableData: TableData[];
  columns: Column[];
  stateData: UsageLocalStorageInterface;
  setStateData: React.Dispatch<
    React.SetStateAction<UsageLocalStorageInterface | null>
  >;
  stateDataKey: "selectedSchools" | "selectedTeachers" | "selectedSections";
}) {
  return tableData && columns ? (
    <Transition
      as="div"
      show={true}
      appear={true}
      enter="transition-opacity duration-300"
      enterFrom="transform opacity-0"
      enterTo="transform opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="transform opacity-100"
      leaveTo="transform opacity-0"
    >
      <DeltaMathTable
        columns={columns}
        data={tableData}
        options={{
          selectable: true,
          showSelectAll: true,
          preSelectedRows: stateData[stateDataKey] ?? {},
        }}
        setSelectedRows={(selectedRows: Record<string, boolean>) => {
          setStateData({
            ...stateData,
            [stateDataKey]: selectedRows,
          });
        }}
      />
    </Transition>
  ) : null;
}

export default UsageSelectionTable;
